"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCheckUpdate = void 0;
const tslib_1 = require("tslib");
const api_1 = tslib_1.__importDefault(require("@/api"));
class AutoCheckUpdate {
    constructor() { }
    static current() {
        if (!AutoCheckUpdate.instance) {
            AutoCheckUpdate.instance = new AutoCheckUpdate();
        }
        return AutoCheckUpdate.instance;
    }
    startAutoCheckUpdate(callback, ms = 1000 * 60 * 10) {
        if (this.intervalId) {
            console.log("检测网站是否更新已开启，无需再次打开！");
            return;
        }
        this.checkUpdate(callback);
        this.intervalId = setInterval(() => {
            this.checkUpdate(callback);
        }, ms);
    }
    checkUpdate(callback) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const scriptTags = yield this.getAllScriptTags();
            if (scriptTags == null)
                return;
            const checkUpdateCallback = (hasUpdate) => {
                this.lastScriptTags = scriptTags;
                callback(hasUpdate);
            };
            if (!this.lastScriptTags) {
                checkUpdateCallback(false);
                return;
            }
            console.log('scriptTags', scriptTags);
            console.log('lastScriptTags', this.lastScriptTags);
            if (scriptTags.length !== this.lastScriptTags.length) {
                checkUpdateCallback(true);
                return;
            }
            for (let i = 0; i < this.lastScriptTags.length; i++) {
                if (!scriptTags.includes(this.lastScriptTags[i])) {
                    checkUpdateCallback(true);
                    return;
                }
            }
            callback(false);
        });
    }
    getAllScriptTags() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const scriptTags = [];
            try {
                let res = yield (0, api_1.default)('home', { timestamp: Date.now() });
                if (res.code === 400) {
                    return null;
                }
                const scriptReg = /<script.*?src="(.*?)"/g;
                scriptReg.lastIndex = 0;
                let match;
                while ((match = scriptReg.exec(res))) {
                    scriptTags.push(match[1]);
                }
                return scriptTags;
            }
            catch (e) {
                console.log(e);
                return null;
            }
        });
    }
    stopAutoCheckUpdate() {
        clearInterval(this.intervalId);
        this.intervalId = null;
        this.lastScriptTags = null;
    }
}
exports.AutoCheckUpdate = AutoCheckUpdate;
